// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "::-webkit-scrollbar{width:7px;height:7px}::-webkit-scrollbar-track{background:#eaeaea}::-webkit-scrollbar-thumb{border-radius:3px;background:#cdcdcd}", ""]);
// Exports
module.exports = exports;
